var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import styled, { css } from "styled-components";
import { Div, HTMLButton } from "../utils";
const ButtonTypes = [
    "primary",
    "secondaryPrimary",
    "secondary",
    "tertiary",
    "destructive",
    "branded",
];
const isDisabledCss = css `
  border: none;
  color: ${(p) => p.theme.colors.black40};
  background: ${(props) => props.theme.colors.gray3};
  pointer-events: none;
`;
const styles = {
    primary: css `
    background: ${(props) => props.theme.colors.navy};
    color: ${(props) => props.theme.colors.white};
    :hover {
      background: ${(props) => props.theme.colors.navy60};
    }
    ${(p) => p.isDisabled && isDisabledCss}
  `,
    secondaryPrimary: css `
    background: ${(props) => props.theme.colors.white};
    border: solid 1px ${(props) => props.theme.colors.navy};
    color: ${(props) => props.theme.colors.navy};
    :hover {
      border: solid 1px transparent;
      background: ${(props) => props.theme.colors.navy60};
      color: ${(p) => p.theme.colors.white};
    }
    ${(p) => p.isDisabled && isDisabledCss}
  `,
    secondary: css `
    background: ${(props) => props.theme.colors.white};
    color: ${(props) => props.theme.colors.black80};
    border: solid 1px ${(p) => p.theme.colors.black20};
    :hover {
      border: solid 1px transparent;
    }
    ${(p) => p.isDisabled && isDisabledCss}
  `,
    tertiary: css `
    background: transparent;
    color: ${(props) => props.theme.colors.black60};
    border: none;
    ${(p) => p.isDisabled &&
        css `
        ${isDisabledCss};
        background: transparent;
        color: ${(p) => p.theme.colors.black40};
      `}
    :hover {
      color: ${(p) => p.theme.colors.black80};
      background: ${(p) => p.theme.colors.gray2};
      box-shadow: none;
    }
  `,
    destructive: css `
    background: ${(p) => p.theme.colors.red};
    color: ${(props) => props.theme.colors.white};
    ${(p) => p.isDisabled && isDisabledCss}
  `,
    branded: css `
    background: linear-gradient(45deg, #1b0076, #e71e3d);
    color: ${(props) => props.theme.colors.white};
    border-radius: 22px;
  `,
};
export const MaxButton = styled(HTMLButton) `
  height: 44px;
  border-radius: 4px;
  border: solid 1px transparent;
  user-select: none;
  padding: 10px 12px;
  :hover {
    cursor: pointer;
    box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.2);
  }
  :focus {
    outline: none;
  }

  font-family: Poppins;
  font-size: 16px;
  font-weight: 600;
  line-height: 23px;
  ${(p) => {
    const c = p.theme.css;
    return [c.centered];
}};

  ${({ variant }) => styles[variant || "primary"]};
`;
export const Button = (_a) => {
    var { onClick = () => { }, isDisabled = false, icon, variant = "primary", children, type = "button" } = _a, props = __rest(_a, ["onClick", "isDisabled", "icon", "variant", "children", "type"]);
    return (React.createElement(MaxButton, Object.assign({ w100: true, alignCenter: true, type: type, tabIndex: 0, onKeyDown: ({ code }) => {
            if (code === "Space" || (code === "Enter" && onClick))
                onClick();
        } }, Object.assign({ variant, isDisabled, onClick }, props)),
        children,
        icon && (React.createElement(Div, { ml: 12, centered: true }, icon))));
};
//# sourceMappingURL=index.js.map